import React from "react";
import * as actions from '../actions';
export default function UploadImgOverlay({ eleRef,tool }) {
    return (

        <div className="uploadImg-overlay" onClick={() => actions.clearMemoryImageData(eleRef,false)}>
        <div className="uploadImg-popup" onClick={(e) => { e.stopPropagation(); return false; }}>
            <div className="uploadImg-header">
                <span className="B14_42">{tool=="recipeDetail" ? "Edit Recipe Image":"UPLOAD PROFILE PHOTO"}</span>
                <span className="closeButton icon" data-icon-font="C" onClick={() => actions.clearMemoryImageData(eleRef, false)}></span>
            </div>
            <div className="uploadImg-container">
                <div className="cropContainer">
                    <div className="img_cntner">
                        <img src="" id="cropbox" className="" crossOrigin="anonymous" />
                    </div>
                </div>
                <input type="hidden" id="pChildId" name="pChildId" />
                <input type="hidden" id="x" name="x" />
                <input type="hidden" id="y" name="y" />
                <input type="hidden" id="w" name="w" />
                <input type="hidden" id="h" name="h" />
                <input id="rx" name="rx" type="hidden" value="" />
                <input id="ry" name="ry" type="hidden" value="" />
                <input id="rw" name="rw" type="hidden" value="" />
                <input id="rh" name="rh" type="hidden" value="" />
                <div className="setImgBtn" onClick={() => actions.checkCoords(eleRef,tool)}>
                    <span className="M14_white">SET IMAGE</span>
                </div>
                <div style={{ display: "none" }}>
                    <canvas id="preview" style={{ width: "1000px", height: "1000px", overflow: "hidden" }}></canvas>
                </div>
            </div>
        </div>
    </div>
    );
}
